import { ListItemIcon, ListItemText, MenuItem } from '@mui/material'
import { MessageRounded } from '@mui/icons-material'
import { ButtonLink } from '../../../../components/wrappers/Button'
import { TtoggleDrawerOnMobile } from '../../../../containers/Sidebar/Sidebar'
import { useIntl } from 'react-intl'

interface MenuEventSummaryProps {
  pathname: string
  nested?: string
  toggleDrawerOnMobile: TtoggleDrawerOnMobile
}

export const MenuEventSummary = ({
  pathname,
  nested,
  toggleDrawerOnMobile,
}: MenuEventSummaryProps) => {
  const { formatMessage } = useIntl()
  return (
    <div onClick={toggleDrawerOnMobile}>
      <MenuItem
        className={nested}
        component={ButtonLink}
        href="/live-chat/event-messages/summary?page=1&page_size=10"
        selected={pathname.startsWith('/live-chat/event-messages/summary')}
      >
        <ListItemIcon>
          <MessageRounded />
        </ListItemIcon>
        <ListItemText
          primary={formatMessage({
            id: 'liveChat.sidebar.eventSummary',
          })}
        />
      </MenuItem>
    </div>
  )
}
